<app-modal-ventas #reporteIndividual></app-modal-ventas>
<div class="container mt-5 ml-3">
    <div class="col-md-12 d-flex align-items-center">
        <h1 style="color: green">Carga y consulta de reportes</h1>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>
    <div class="col-md-12 d-flex align-items-center">
        <h2 class="mb-0" style="color: black; font-weight: bold">
            Registro de ventas e inventario
        </h2>
        <a
            class="btn btn-primary btn_color ml-3"
            (click)="downloadInstructive()">
            Descargar instructivo
        </a>
    </div>
    <div class="row mt-3">
        <div class="col-md-4">
            <div class="card">
                <div class="card-body fondo-hover">
                    <h5 class="card-title card-titulo-negrita">
                        Reporte por carga masiva
                    </h5>
                    <p class="card-text"></p>
                    <p class="card-text">
                        {{ 'reporte.cuerpoCargaMasiva' | translate }}
                    </p>
                    <div class="card-text container_btn-reporte">
                        <a
                            class="btn btn-primary btn_color"
                            (click)="downloadReport()">
                            Descargar plantilla
                        </a>

                        <p class="card-text link">
                            <a
                                class="btn btn-primary btn_color"
                                (click)="openMassUploadModal(modalLoadReport)">
                                Carga masiva
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-4 fondo-hover">
            <div class="card">
                <div
                    class="card-body"
                    style="z-index: 10"
                    (click)="reporteManual()">
                    <h5 class="card-title card-titulo-negrita">
                        Reporte individual
                    </h5>
                    <p class="card-text">
                        {{ 'reporte.textoCarguaIndividual' | translate }}
                    </p>

                    <div
                        *ngIf="ultimoObjetoCreado"
                        (click)="continuarReporte()">
                        <p class="card-text reporte_continuar">
                            Tienes un reporte guardado para continuar.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tercera Card -->
        <div class="col-md-4">
            <div class="card">
                <div class="card-body fondo-hover">
                    <h5 class="card-title card-titulo-negrita">
                        Consulta cargues históricos
                    </h5>
                    <p class="card-text">
                        {{ 'reporte.textoCargueHistorico' | translate }}
                    </p>
                    <p class="card-text">
                        <a class="link-action" (click)="irConsultaReportes()">
                            Consulta reportes
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container mt-5 second-container">
    <h2 style="color: black; font-weight: bold">
        Consultar reportes y certificados de la empresa:
        {{ empresaSeleccionada }}
    </h2>

    <ul class="nav nav-tabs mt-3">
        <li class="nav-item">
            <a
                class="nav-link active"
                id="tabReportes"
                data-bs-toggle="tab"
                href="#reportes">
                Reportes
            </a>
        </li>
        <li class="nav-item">
            <a
                class="nav-link"
                id="tabCertificados"
                data-bs-toggle="tab"
                href="#certificados"
                (click)="showCertificates()">
                Certificados
            </a>
        </li>
    </ul>

    <div class="tab-content mt-3">
        <div class="tab-pane fade show active" id="reportes">
            <div class="container mt-3">
                <div class="row">
                    <div class="col-md-3">
                        <label for="selectMes">Mes:</label>
                        <select
                            class="form-select"
                            id="selectMes"
                            [(ngModel)]="selectedMonth"
                            (change)="historyReport()">
                            <option
                                *ngFor="let month of months"
                                [value]="month.value">
                                {{ month.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <label for="selectAnio">Año:</label>
                        <select
                            class="form-select"
                            id="selectAnio"
                            [(ngModel)]="selectedYear"
                            (change)="historyReport()">
                            <option *ngFor="let year of years" [value]="year">
                                {{ year }}
                            </option>
                        </select>
                    </div>

                    <table class="table mt-3">
                        <thead>
                            <tr>
                                <th>Año</th>
                                <th>Mes</th>
                                <th>Fecha de carga</th>
                                <th>Autor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="lastReport">
                                <td>{{ lastReport.anio }}</td>
                                <td>
                                    {{
                                        mapPeriodToMonthName(lastReport.periodo)
                                    }}
                                </td>
                                <td>{{ lastReport.fechaRegistro }}</td>
                                <td>{{ lastReport.nombreRepresentante }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            [class]="
                showCertificados ? 'tab-pane fade show active' : 'tab-pane fade'
            "
            id="certificados">
            <table class="table mt-3">
                <thead>
                    <tr>
                        <th>Año</th>
                        <th>Mes</th>
                        <th>Fecha de reporte</th>
                        <th>Descarga</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="lastReport">
                        <td>{{ lastReport.anio }}</td>
                        <td>{{ lastReport.periodo }}</td>
                        <td>{{ lastReport.fechaRegistro }}</td>
                        <td>
                            <button
                                class="btn btn-primary"
                                (click)="descargarCertificado()">
                                <i class="bi bi-download"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #modalLoadReport>
    <div class="modal-content">
        <div class="modal-header border-0">
            <h5 class="modal-title">Carga masiva ventas e inventarios</h5>
            <button
                type="button"
                class="close"
                (click)="closeMassUploadModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div
            class="modal-body border-0 d-flex align-items-center justify-content-center">
            <div class="row">
                <div class="col title-file">
                    <p>{{ 'reporte.textoModalCargaMasiva' | translate }}</p>
                </div>
                <div
                    class="row container-file"
                    style="border: 1px dashed #ccc; padding: 10px">
                    <label for="fileInput" style="width: 100%; cursor: pointer">
                        <div class="col" *ngIf="!selectedFile">
                            <div class="container text-center">
                                <h5>Carga el archivo</h5>
                                <p class="text-muted">.xlsx- Max 2 Mb</p>
                                <input
                                    type="file"
                                    id="fileInput"
                                    style="display: none"
                                    (change)="onFileSelected($event)" />
                            </div>
                        </div>
                    </label>
                    <div class="col text-center">
                        <div
                            *ngIf="selectedFile && !filesend && !fileUploaded"
                            class="text-center">
                            <p>{{ selectedFile.name }}</p>
                            <p>{{ getFileSize(selectedFile.size) }}</p>
                        </div>
                        <div
                            *ngIf="filesend && !fileUploaded"
                            class="text-center">
                            <p>
                                <i class="fas fa-check-circle"></i>
                                Archivo enviado!
                            </p>
                        </div>
                        <div *ngIf="fileUploaded" class="text-center">
                            <p>¿ Desea reemplazar el reporte anterior?</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer border-0 justify-content-center">
            <button
                *ngIf="!fileUploaded"
                type="button"
                class="btn btn-success"
                (click)="saveMassUpload()"
                [disabled]="filesend">
                Guardar
            </button>
            <button
                *ngIf="fileUploaded"
                type="button"
                class="btn btn-warning"
                (click)="replaceFile()">
                Reemplazar
            </button>
        </div>
    </div>
</ng-template>
